module.exports = __webpack_public_path__ + "static/media/closeBlack.47f1726d.svg";